export const NEW_SECTION = 'New Section';
export const SECTION_1 = 'Section 1';
export const DUPLICATE = 'Duplicate';
